import React from "react";

const DrawOutlineButton = ({ children, onClick }) => {
    return (
        <button
            onClick={onClick}
            className="bg-color3 hover:bg-primaryActive text-white 
            text-sm py-2.5 px-5 rounded-xl shadow-md hover:translate-y-[-2px] transition duration-300"
        >
            {children}
        </button>
    );
};

export default DrawOutlineButton;
